import React, { useEffect, useState } from "react";
import { Grid, Typography, styled, Box, Button, Stack } from "@mui/material";
import { ImgBox, IncrementBox, TextIcrement } from "./style";
import NoImgIcon from "../../images/item icon.svg";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Search from "../../components/components/Search";
import { useHistory, useParams } from "react-router-dom";
import StoreHeader from "./StoreHeader";
import Repo from "../../Repository/Repo";
import Loader from "../../components/components/Loader";
import { Toast } from "../../components/components/Toast";

const Title = styled(Typography)({
  fontFamily: "Roboto",
  fontSize: "17px",
  fontWeight: 600,
  color: "#323232",
});

function PublicStore() {
  const { id } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [storeData, setStoreData] = useState([]);

  useEffect(() => {
    getItems();
  }, []);

  const getItems = async () => {
    try {
      setLoading(true);
      let { data } = await Repo.store({
        request: {
          method: "getStoreDataByUserName",
          data: {
            userName: id,
          },
        },
      });
      setLoading(false);
      if (data.response.data.storeData) {
        setStoreData(data.response.data.storeData);
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  const handleAdd = (item) => {
    let copy = JSON.parse(JSON.stringify(storeData.itemsArray));
    let found = copy.find((i) => i._id == item._id);
    found.saleQuantity = 1;
    setStoreData((prev) => ({ ...prev, itemsArray: copy }));
  };

  const increaseQty = (item) => {
    let copy = JSON.parse(JSON.stringify(storeData.itemsArray));
    let found = copy.find((i) => i._id == item._id);
    found.saleQuantity += 1;
    setStoreData((prev) => ({ ...prev, itemsArray: copy }));
  };
  const decreaseQty = (item) => {
    let copy = JSON.parse(JSON.stringify(storeData.itemsArray));
    let found = copy.find((i) => i._id == item._id);
    found.saleQuantity -= 1;
    setStoreData((prev) => ({ ...prev, itemsArray: copy }));
  };

  const handleInput = (e) => {
    const { value } = e.target;
    setFilterText(value);
  };

  const filteredItems = () => {
    if (filterText) {
      let filtered = storeData?.itemsArray.filter((i) =>
        i.name.toString().toLowerCase().startsWith(filterText.toLowerCase())
      );
      return filtered;
    } else {
      return storeData?.itemsArray || [];
    }
  };

  const getCount = () => {
    let price = 0;
    let count = 0;
    storeData?.itemsArray?.forEach((item) => {
      if (item?.saleQuantity) {
        count += 1;
        price += parseInt(item.price) * item.saleQuantity || 0;
      }
    });

    return { price, count };
  };

  const handleViewCart = () => {
    let filtered = storeData.itemsArray.filter((i) => i?.saleQuantity);
    if (filtered.length > 0) {
      history.push({
        pathname: `/store/${id}/cart`,
        state: {
          items: filtered,
          storeName: storeData.storeName,
          userName: storeData.userName,
        },
      });
    } else {
      Toast("info", "Kindly select items");
    }
  };

  return (
    <Box sx={{ background: "#E8E8E8", py: "16px", px: "32px" }}>
      <StoreHeader
        title={storeData?.storeName}
        userName={storeData.userName}
        address={storeData?.address}
        image={storeData?.image || ""}
      />
      <Box sx={{ background: "#fff", p: "12px 32px", mt: "16px" }}>
        <Grid
          container
          spacing={4}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Grid item md={4} xs={12}>
            <Search
              name="searchText"
              text="Search item..."
              value={filterText}
              onChange={handleInput}
            />
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Stack direction="row" alignItems="center" spacing="16px">
              <Title sx={{ color: "#4CAF50" }}>
                {getCount().count} ITEMS . Rs: {getCount().price} |
              </Title>
              <Button
                variant="contained"
                size="small"
                sx={{
                  background: "#9FF1A2 !important",
                  color: "#323232",
                  textTransform: "none",
                  boxShadow: "none !important",
                }}
                onClick={handleViewCart}
              >
                <ShoppingCartIcon sx={{ mr: "8px" }} />
                View Cart
              </Button>
            </Stack>
          </Grid>
        </Grid>

        {!loading && (
          <Grid my="16px" container spacing="16px">
            {filteredItems()?.map((item, i) => {
              return (
                <Grid key={i} item md={2} sm={6} xs={12}>
                  <Box sx={{ borderRadius: "8px" }}>
                    <Box sx={{ background: "#E8E8E8", p: "24px" }}>
                      <img
                        style={{ height: "200px", width: "100%" }}
                        src={item?.imgURL ? item.imgURL : NoImgIcon}
                        alt="item icon"
                      />
                    </Box>
                    <Box sx={{ px: "8px" }}>
                      <Title sx={{ fontWeight: 700 }}>{item.name}</Title>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: "8px",
                      }}
                    >
                      <Typography>Rs : {item?.price}</Typography>

                      {item?.saleQuantity ? (
                        <IncrementBox>
                          <RemoveIcon
                            sx={{
                              cursor: "pointer",
                              fontSize: "18px",
                              color: "#332233",
                            }}
                            onClick={() => decreaseQty(item)}
                          />
                          <TextIcrement>{item.saleQuantity}</TextIcrement>

                          <AddIcon
                            sx={{
                              cursor: "pointer",
                              fontSize: "18px",
                              color: "#332233",
                            }}
                            onClick={() => increaseQty(item)}
                          />
                        </IncrementBox>
                      ) : (
                        <Button
                          size="small"
                          variant="contained"
                          sx={{
                            borderRadius: "50px",
                            background: "#ACFFCD !important",
                            color: "#323232",
                            px: "32px",
                            boxShadow: "none !important",
                          }}
                          onClick={() => handleAdd(item)}
                        >
                          <AddCircleIcon sx={{ mr: "8px" }} /> Add
                        </Button>
                      )}
                    </Box>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        )}
        {loading && <Loader />}
      </Box>
    </Box>
  );
}

export default PublicStore;
